import type { CSSProperties, ReactNode } from 'react';

// Light/dark pairs are the ones documented in CLAUDE.md's "State Colors" table.
const BADGE_COLORS = {
  blue: 'bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-200',
  green: 'bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-200',
  red: 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-200',
  yellow: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/50 dark:text-yellow-200',
  lime: 'bg-lime-100 text-lime-800 dark:bg-lime-900/50 dark:text-lime-200',
  gray: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400',
  orange: 'bg-orange-100 text-orange-800 dark:bg-orange-900/50 dark:text-orange-200',
} as const;

export type BadgeColor = keyof typeof BADGE_COLORS;

interface BadgeProps {
  color?: BadgeColor;
  /** Replaces the palette colour - for badges whose colour comes from a domain helper. */
  colorClass?: string;
  /** Appended to the badge, e.g. spacing. Does not affect the colour. */
  className?: string;
  title?: string;
  style?: CSSProperties;
  children: ReactNode;
}

export default function Badge({ color = 'gray', colorClass, className = '', title, style, children }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${colorClass ?? BADGE_COLORS[color]} ${className}`}
      title={title}
      style={style}
    >
      {children}
    </span>
  );
}
